<script setup lang="ts">
import { sortItems } from '@/modules/filing/utils/utils'
import { useFilingStore } from '@/modules/filing/stores/filing-store'
import VFolder from './VFolder.vue'
import VFile from './VFile.vue'
import { computed } from 'vue'

const props = defineProps<{
  openFolder: Function
  addFolder: Function
  editFolder: Function
  onFolderDragStart: Function
  onItemDrop: Function
  onSelectRow: Function
  selectedKeys: string[]
  onFileDragStart: Function
  sortState: { column: string; direction: string }
}>()

const filingStore = useFilingStore()

const sortedFolders = computed(() => {
  const folders = filingStore.searchResults.folders
  return sortItems(folders, props.sortState)
})

const sortedFiles = computed(() => {
  const files = filingStore.searchResults.files
  return sortItems(files, props.sortState)
})
</script>

<template>
  <div class="v-folder-tree">
    <VFolder
      v-for="folder in sortedFolders"
      :key="folder.id"
      :folder="folder"
      :level="0"
      :isExpanded="false"
      :openFolder="openFolder"
      :addFolder="addFolder"
      :editFolder="editFolder"
      :onFolderDragStart="onFolderDragStart"
      :onItemDrop="onItemDrop"
      :onSelect="onSelectRow"
      :selectedKeys="selectedKeys"
    />
    <VFile
      v-for="file in sortedFiles"
      :key="file.id"
      :file="file"
      :level="0"
      :onFileDragStart="onFileDragStart"
      :onItemDrop="onItemDrop"
      :onSelect="onSelectRow"
      :selectedKeys="selectedKeys"
    />
  </div>
</template>

<style scoped>
.v-folder-tree {
  @apply col-span-4;
}
</style>
